import { render, staticRenderFns } from "./QueueAvatar.vue?vue&type=template&id=8f449446&scoped=true&lang=pug"
import script from "./QueueAvatar.vue?vue&type=script&lang=js"
export * from "./QueueAvatar.vue?vue&type=script&lang=js"
import style0 from "./QueueAvatar.vue?vue&type=style&index=0&id=8f449446&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f449446",
  null
  
)

export default component.exports